import React from "react";
import { FooterSubscribe, OnlyFooter } from "../../Layout/Footer";

const TermsCon = () => {
  return (
    <>
      <div
        className="hp-container mt-5 tnc"
        style={{
          fontFamily: "Arial, sans-serif",
          lineHeight: "1.6",
          padding: "20px",
        }}
      >
        <h1>Stagobox Pvt Ltd: Terms &amp; Conditions</h1>
        <p>
          <b>Last Updated:</b> 12 December 2024
        </p>
        <h2>1. Introduction</h2>
        <p>
          These Terms &amp; Conditions (“Agreement”) are entered into by and
          between <b>Stagobox Pvt Ltd</b> (“Stagobox”, “we”, “our”, or “us”) and
          you, the customer (“you”, “your”, or “client”).
          <br />
          By using our website and services, you agree to be bound by this
          Agreement.
        </p>
        <div style={{ textAlign: "center" }}>
          <hr style={{ width: "100%" }} />
        </div>
        <h2>2. Services</h2>
        <p>
          Stagobox provides digital visualization and graphic design services
          for real estate and related industries, including:
        </p>
        <ul style={{ marginTop: "0px" }}>
          <li>Virtual Staging (Residential &amp; Commercial)</li>
          <li>Virtual Renovation</li>
          <li>Occupied-to-Vacant Editing</li>
          <li>Day-to-Dusk Conversions</li>
          <li>Object Removal</li>
          <li>Floor Plans</li>
          <li>Graphics Design (branding, marketing assets)</li>
        </ul>
        <div style={{ textAlign: "center" }}>
          <hr style={{ width: "100%" }} />
        </div>
        <h2>3. Eligibility</h2>
        <ul style={{ marginTop: "0px" }}>
          <li>
            You must be of legal age in your jurisdiction to use our services.
          </li>
          <li>
            Our services are not intended for individuals under the age of 16.
          </li>
        </ul>
        <div style={{ textAlign: "center" }}>
          <hr style={{ width: "100%" }} />
        </div>
        <h2>4. Client Responsibilities</h2>
        <ul style={{ marginTop: "0px" }}>
          <li>Provide accurate and high-quality images for processing.</li>
          <li>Ensure content does not infringe third-party rights.</li>
          <li>Approve deliverables promptly to avoid delays.</li>
        </ul>
        <div style={{ textAlign: "center" }}>
          <hr style={{ width: "100%" }} />
        </div>
        <h2>5. Payment Terms</h2>
        <ul style={{ marginTop: "0px" }}>
          <li>
            Payment must be made prior to final delivery unless otherwise
            agreed.
          </li>
          <li>
            Accepted payment methods include credit card, PayPal, or Paddle.
          </li>
          <li>
            Late or incomplete payments may result in suspension of service.
          </li>
        </ul>
        <div style={{ textAlign: "center" }}>
          <hr style={{ width: "100%" }} />
        </div>
        <h2>6. Intellectual Property</h2>
        <ul style={{ marginTop: "0px" }}>
          <li>Clients retain ownership of original materials they provide.</li>
          <li>Copyright of final deliverables transfers upon full payment.</li>
          <li>
            Stagobox may showcase completed work in its portfolio unless
            requested otherwise.
          </li>
        </ul>
        <div style={{ textAlign: "center" }}>
          <hr style={{ width: "100%" }} />
        </div>
        <h2>7. Limitation of Liability</h2>
        <ul style={{ marginTop: "0px" }}>
          <li>Services are provided “as is” without warranties.</li>
          <li>
            Liability is limited to the amount paid for the specific service.
          </li>
          <li>Stagobox is not liable for indirect or consequential damages.</li>
        </ul>
        <div style={{ textAlign: "center" }}>
          <hr style={{ width: "100%" }} />
        </div>
        <h2>8. Termination</h2>
        <ul style={{ marginTop: "0px" }}>
          <li>You may cancel your account or services at any time.</li>
          <li>
            Stagobox may suspend or terminate services for violations of these
            Terms.
          </li>
        </ul>
        <div style={{ textAlign: "center" }}>
          <hr style={{ width: "100%" }} />
        </div>
        <h2>9. Governing Law</h2>
        <p>This Agreement is governed by the laws of India.</p>
      </div>
      <FooterSubscribe />

      <OnlyFooter />
    </>
  );
};

export default TermsCon;
